// extracted by mini-css-extract-plugin
module.exports = {"srOnlyFocus":"classes_srOnlyFocus__YJbb9","srOnly":"classes_srOnly__niN4S","skeleton":"classes_skeleton__kWgyk","skeleton-animation":"classes_skeleton-animation__h28LE"};